import React from "react"
import {AdditionalFees as AF} from "../../../dtos/orderResponse"
import Price from "../../formatting/Price"
import {getFeeName, getSurchargeTooltipMessage} from "../../../utils/orderFeesHelper"
import {Grid, Typography, Tooltip, IconButton} from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"

interface AdditionalFeesProps {
	additionalFees: AF
	currency: string
	fractionDigits: number
}

export default function AdditionalFees(props: AdditionalFeesProps) {
	const fees =
		props.additionalFees.fees && props.additionalFees.fees.length > 0
			? props.additionalFees.fees
			: props.additionalFees.feesV2
	return (
		<div>
			{fees && fees.length > 0 && (
				<div>
					<Typography style={{fontWeight: "bold", display: "inline-block"}}>Fees</Typography>
					{fees.map((fee) => (
						<div>
							<Grid container justifyContent="space-between" alignItems="center">
								<Grid item xs={6} style={{display: "flex", alignItems: "center"}}>
									<Typography variant="subtitle1">{getFeeName(fee)}</Typography>
								</Grid>
								<Grid item xs={6}>
									<Typography
										variant="caption"
										style={{fontWeight: 300, color: "gray", fontSize: "11px"}}
									>
										<Price
											value={
												fee.discountedPriceCents.taxed
													? String(fee.discountedPriceCents.untaxed)
													: "0"
											}
											fractionDigits={props.fractionDigits}
											currency={props.currency}
										/>
									</Typography>
									{getFeeName(fee) === "Surcharge" && (
										<Tooltip title={getSurchargeTooltipMessage()}>
											<IconButton aria-label="info">
												<InfoIcon />
											</IconButton>
										</Tooltip>
									)}
								</Grid>
							</Grid>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
